/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ParcelVo
 */
export interface ParcelVo {
    /**
     * 快递单ID
     * @type {number}
     * @memberof ParcelVo
     */
    id?: number;
    /**
     * 用户ID
     * @type {number}
     * @memberof ParcelVo
     */
    userId?: number;
    /**
     * 仓库ID
     * @type {number}
     * @memberof ParcelVo
     */
    warehouseId?: number;
    /**
     * 运单号
     * @type {string}
     * @memberof ParcelVo
     */
    trackingNumber?: string;
    /**
     * 包裹状态 1 待入库， 2 已签收， 3 已入库
     * @type {number}
     * @memberof ParcelVo
     */
    status?: number;
    /**
     * 包裹名称
     * @type {string}
     * @memberof ParcelVo
     */
    name?: string;
    /**
     * 到付金额
     * @type {number}
     * @memberof ParcelVo
     */
    carriageForward?: number;
    /**
     * 货币代码
     * @type {string}
     * @memberof ParcelVo
     */
    currencyCode?: string;
    /**
     * 包裹内产品数量
     * @type {number}
     * @memberof ParcelVo
     */
    number?: number;
    /**
     * 是否为主运单，0 不是， 1 是
     * @type {number}
     * @memberof ParcelVo
     */
    main?: number;
}

/**
 * Check if a given object implements the ParcelVo interface.
 */
export function instanceOfParcelVo(value: object): value is ParcelVo {
    return true;
}

export function ParcelVoFromJSON(json: any): ParcelVo {
    return ParcelVoFromJSONTyped(json, false);
}

export function ParcelVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParcelVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'warehouseId': json['warehouseId'] == null ? undefined : json['warehouseId'],
        'trackingNumber': json['trackingNumber'] == null ? undefined : json['trackingNumber'],
        'status': json['status'] == null ? undefined : json['status'],
        'name': json['name'] == null ? undefined : json['name'],
        'carriageForward': json['carriageForward'] == null ? undefined : json['carriageForward'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
        'number': json['number'] == null ? undefined : json['number'],
        'main': json['main'] == null ? undefined : json['main'],
    };
}

export function ParcelVoToJSON(json: any): ParcelVo {
    return ParcelVoToJSONTyped(json, false);
}

export function ParcelVoToJSONTyped(value?: ParcelVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userId': value['userId'],
        'warehouseId': value['warehouseId'],
        'trackingNumber': value['trackingNumber'],
        'status': value['status'],
        'name': value['name'],
        'carriageForward': value['carriageForward'],
        'currencyCode': value['currencyCode'],
        'number': value['number'],
        'main': value['main'],
    };
}

